import { render } from "./CheckboxCommon.vue?vue&type=template&id=6e4064cc&scoped=true"
import script from "./CheckboxCommon.vue?vue&type=script&lang=js"
export * from "./CheckboxCommon.vue?vue&type=script&lang=js"

import "./CheckboxCommon.vue?vue&type=style&index=0&id=6e4064cc&scoped=true&lang=css"

import exportComponent from "/var/www/intercity.dev-jatri.jatritech.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e4064cc"]])

export default __exports__